import { render, staticRenderFns } from "./MRC.vue?vue&type=template&id=27f680db&"
import script from "./MRC.vue?vue&type=script&lang=ts&"
export * from "./MRC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f680db')) {
      api.createRecord('27f680db', component.options)
    } else {
      api.reload('27f680db', component.options)
    }
    module.hot.accept("./MRC.vue?vue&type=template&id=27f680db&", function () {
      api.rerender('27f680db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/MRC.vue"
export default component.exports